/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const HeartRegularV6 = (props) => (
  <Icon {...props} name="Heart Regular V6">
    <path d="M7.625 2.625 7.972 3l.375-.374a4.548 4.548 0 0 1 3.922-1.248A4.466 4.466 0 0 1 16 5.784v.181a4.673 4.673 0 0 1-1.488 3.422l-5.647 5.272a1.268 1.268 0 0 1-1.732 0L1.486 9.387A4.678 4.678 0 0 1-.001 5.965v-.181A4.466 4.466 0 0 1 3.73 1.378a4.492 4.492 0 0 1 3.894 1.247c-.028 0 0 0 0 0zm.347 2.497L6.566 3.66a3.033 3.033 0 0 0-2.587-.802 2.967 2.967 0 0 0-2.478 2.927v.181c0 .881.366 1.725 1.011 2.325l5.489 5.125 5.491-5.125a3.18 3.18 0 0 0 1.009-2.325v-.181a2.97 2.97 0 0 0-2.478-2.927 3.029 3.029 0 0 0-2.587.802L7.973 5.122z" />
  </Icon>
);

export default HeartRegularV6;
